export default __webpack_public_path__ + "static/media/tetherlogo.6dc09781.svg";